// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.MuiTypography-h3,
.MuiTypography-h4,
.MuiTypography-h5,
.MuiTypography-h6 {
  padding-top: 1em;
}

.content {
  margin: 0 auto;
  padding: 2em;
}

.lti-oauth2 .warning {
  margin: 0.25em;
  padding: 0.5em;
  border: 1px solid;
  text-align: center;
}
`, "",{"version":3,"sources":["webpack://./src/Host/host.css"],"names":[],"mappings":"AAAA;;;;EAIE,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,YAAY;AACd;;AAEA;EACE,cAAc;EACd,cAAc;EACd,iBAAiB;EACjB,kBAAkB;AACpB","sourcesContent":[".MuiTypography-h3,\n.MuiTypography-h4,\n.MuiTypography-h5,\n.MuiTypography-h6 {\n  padding-top: 1em;\n}\n\n.content {\n  margin: 0 auto;\n  padding: 2em;\n}\n\n.lti-oauth2 .warning {\n  margin: 0.25em;\n  padding: 0.5em;\n  border: 1px solid;\n  text-align: center;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
